import * as React from "react";
import TableTemplate from "../common/TableTemplate";
import { generateDynamicColumns } from "../../utils/generateDynamicColumns";
import { useMemo } from "react";
import { columnHelper } from "../../utils/utils";
import { useUpdateAliLinkMutation } from "../../services/product";
import toast from "react-hot-toast";

export function ProductInfo({ product }) {
  const [updateAliLink, { isLoading, isError, error }] =
    useUpdateAliLinkMutation();

  const columns = useMemo(
    () =>
      generateDynamicColumns({
        columnHelper,
        headerData: product.first_column,
        editableFields: {
          status: {
            inputType: "select",
          },
          is_addon: {
            inputType: "select",
          },
          ali_link: {
            async onHeaderSave(key, newValue) {
              const result = await updateAliLink([
                {
                  class: "Product",
                  glid: product?.data?.glid?.display,
                  update: {
                    ali_link: newValue,
                  },
                },
              ]);

              if ("error" in result) {
                toast.error("Something went wrong. Please try again.");
                console.log("Failed updating ali link: ", result.error);
                return;
              }
              toast.success("Ali link updated successfully.");
            },
            onHeaderCancel(key) {
              console.log("cancelled changing ali link on row: ", key);
            },
          },
        },
        navigationConfig: {
          shop_name: {
            navigable: true,
            target: "_blank",
            getUrl: ({ originalRow }) => {
              return { pathname: originalRow.uri.display, state: null };
            },
          },
        },
        enableRowSelection: false,
        columnTypes: {
          actionsColumn: false,
          rowSelectionColumn: false,
        },
      }),
    [updateAliLink, product]
  );

  // this is done to avoid creating an inline array
  // which is not good for performance
  const data = useMemo(() => {
    if (!product?.data) return [];
    return [product.data];
  }, [product.data]);

  return (
    <div className="bg-white rounded-lg">
      {/* <h1 className="text-3xl font-bold text-amber-700 mb-2">{product.product_name}</h1> */}
      <a
        href={product.uri}
        target="_blank"
        rel="noopener noreferrer"
        className="text-3xl font-bold text-amber-700 mb-2"
      >
        {product.name}
      </a>
      {/* <p className="text-2xl font-semibold text-gray-900 mb-6">
          ${product.variants[0]?.price}
        </p> */}

      <div className="border border-gray-200 rounded-lg overflow-hidden">
        <TableTemplate
          columns={columns}
          // data={product.general_data.table.data}
          // well, this isn't good. it's an inline array, and it's not good for performance
          // data={[product.data] || []}
          // we can write it like this:
          data={data}
          layout="keyValue"
          title={"Product Information"}
          // I don't think we need this, do we?
          titleUrl=""
          tableClassName="w-full"
          options={{
            enableRowSelection: false,
          }}
        />
      </div>
    </div>
  );
}
